export default __webpack_public_path__ + "static/media/dance.52be80c0.jpeg";